export interface IAmericanState {
  id: number;
  name: string;
  code: string;
}

export class AmericanState implements IAmericanState {
  id;
  name;
  code;

  constructor(config: IAmericanState) {
    this.id = config.id;
    this.name = config.name;
    this.code = config.code;
  }
}
